import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Team", href: "#team" },
  { label: "FAQ", href: "#faq" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="site-navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-background/80 backdrop-blur-xl border-b border-border" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" onClick={(e) => { e.preventDefault(); go("#top"); }}
           className="flex items-center gap-3 group">
          <img src="/assets/fg-logo.png" alt="Faith & Grace Advisory Services"
               className="h-11 md:h-12 w-auto transition-transform duration-300 group-hover:scale-[1.03]" />
        </a>

        <div className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button key={l.href} data-testid={`nav-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="link-underline text-sm text-muted-foreground hover:text-primary transition-colors">
              {l.label}
            </button>
          ))}
          <button data-testid="nav-consultation-btn" onClick={() => go("#contact")}
            className="rounded-full bg-primary text-primary-foreground text-sm px-5 py-2.5 hover:bg-[hsl(var(--gold))] hover:text-primary transition-colors duration-300">
            Schedule Consultation
          </button>
        </div>

        <button data-testid="mobile-menu-btn" className="md:hidden text-primary" onClick={() => setOpen(!open)}>
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-background border-b border-border">
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <button key={l.href} data-testid={`mobile-nav-${l.label.toLowerCase()}`} onClick={() => go(l.href)}
                  className="text-left text-lg font-serif text-primary">{l.label}</button>
              ))}
              <button data-testid="mobile-nav-consultation-btn" onClick={() => go("#contact")}
                className="rounded-full bg-primary text-primary-foreground px-5 py-3 mt-2">Schedule Consultation</button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
